import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import ModalMultimedia from '../../Partials/ModalMultimedia';

export default class AgregarGuiaExportador extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            tituloLongitud:0,
            descripcionLongitud:0,
            resource: {
                gexp_Titulo:"",
                gexp_Descripcion:"",
                gexp_ArchivoPdf:"",
                gexp_Cover:"",
                sect_Id:0,
                gexp_Orden:this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                gexp_Activo:true
            },
            Validacion: {
                gexp_Titulo: {
                    Error: false,                    
                },
                gexp_Descripcion: {
                    Error: false,                    
                },
                gexp_ArchivoPdf: {
                    Error: false,                    
                },
                gexp_Cover: {
                    Error: false,                    
                },
                sect_Id: {
                    Error: false,                    
                },
                gexp_Orden: {
                    Error: false,                    
                }
            },
            sectores: [],
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
      }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
    
            this.setState({resource:resource, fieldReturnMultimedia:""});
        }
    
        hideModalPageClass("divGestorArchivosMultimedia");
    }
    
    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }
    
    handleClickCancel(e) {

        e.preventDefault();

        const {history: {push}} = this.props;    
        push('/guia-exportador');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.gexp_Titulo == '') {              
            newState.Validacion.gexp_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.gexp_Descripcion == '') {  
            newState.Validacion.gexp_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.gexp_ArchivoPdf == '') {  
            newState.Validacion.gexp_ArchivoPdf = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.gexp_Cover == "") {  
            newState.Validacion.gexp_Cover = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.gexp_Orden == '' || newState.resource.gexp_Orden == 0) {  
            newState.Validacion.gexp_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}GuiaExportadorUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'gexp_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                
                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.gexp_Titulo = '';
                stateResponse.resource.gexp_Descripcion = '';
                stateResponse.resource.gexp_ArchivoPdf = '';
                stateResponse.resource.gexp_Cover = '';
                stateResponse.resource.sect_Id = 0;
                stateResponse.resource.gexp_Orden += 1 ;
                document.getElementById("sect_Id").selectedIndex = 0;
                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'gexp_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'gexp_Descripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });  
    }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/guia-exportador";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}GuiaExportadorUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    sectores: data.result.sectores
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Guía Exportador</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Guía Exportador
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='gexp_Titulo' value={this.state.resource.gexp_Titulo} maxLength={35} className={this.state.Validacion.gexp_Titulo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={35}>{this.state.tituloLongitud}/35</span>
                    </div>

                    <div className="txtFile x-1">
                        <input type="text" placeholder="Descripción" name='gexp_Descripcion' value={this.state.resource.gexp_Descripcion} maxLength={250} className={this.state.Validacion.gexp_Descripcion.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={250}>{this.state.descripcionLongitud}/250</span>
                    </div>

                    <div className="txtFile x-1">
                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "gexp_ArchivoPdf")}/>
                        <input type="text" placeholder="Archivo" name='gexp_ArchivoPdf' value={this.state.resource.gexp_ArchivoPdf} className={this.state.Validacion.gexp_ArchivoPdf.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "gexp_Cover")}/>
                        <input type="text" placeholder="Cover" name='gexp_Cover' value={this.state.resource.gexp_Cover} className={this.state.Validacion.gexp_Cover.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Sector</option>
                            {
                                this.state.sectores.length > 0 ?
                                this.state.sectores.map((sector) => (
                                    <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>

                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='gexp_Orden' value={this.state.resource.gexp_Orden} maxLength={2} className={this.state.Validacion.gexp_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}